function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { getSizedImageUrl } from '@shopify/theme-images';
import LILOneThreeSixFlavorSelector from './containers/lilFlavorSelector';
import PDPOneThreeSixFlavorSelector from './containers/pdpFlavorSelector';
import VIPFlavorSelector from './containers/vipFlavorSelector';
export function initProductData() {
  var _productData, _productData$tags, _window$bt;

  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var productData = product;

  if (!productData) {
    var productJson = $('#product-json').html();

    try {
      productData = JSON.parse(productJson);
    } catch (err) {
      console.error('Failed parsing product data', err);
      productData = {};
    }
  }

  productData.isOneThreeSixFlavor = ((_productData = productData) === null || _productData === void 0 ? void 0 : (_productData$tags = _productData.tags) === null || _productData$tags === void 0 ? void 0 : _productData$tags.includes('1_3_6_Flavor_Offer')) || false;
  var productMetafieldData = ((_window$bt = window.bt) === null || _window$bt === void 0 ? void 0 : _window$bt.productsMetaMap[productData.id]) || {};
  productData.metadata = _objectSpread({}, productMetafieldData);

  if (!productMetafieldData.variantsMetaMap) {
    console.warn('Metafield data is missing for product.');
  }

  var variantMetafieldData = productMetafieldData.variantsMetaMap || {};
  productData.variants.forEach(function (variant) {
    variant.metafields = variantMetafieldData[variant.id] || {};

    if (variant.featured_image) {
      // eslint-disable-next-line
      variant.featured_image_thumbnail = {
        id: variant.featured_image.id,
        src: getSizedImageUrl(variant.featured_image.src, '150x150'),
        alt: variant.featured_image.alt,
        height: 150,
        width: 150
      };
    }
  });
  return productData;
}
export function initLILFlavorSelector(_ref) {
  var rootElement = _ref.rootElement,
      _ref$flavorCYPs = _ref.flavorCYPs,
      flavorCYPs = _ref$flavorCYPs === void 0 ? [] : _ref$flavorCYPs;

  if (!flavorCYPs.length) {
    return;
  }

  Modal.setAppElement(rootElement);
  var componentContainer = document.createElement('div');
  document.body.appendChild(componentContainer);
  ReactDOM.render( /*#__PURE__*/React.createElement(LILOneThreeSixFlavorSelector, {
    flavorCYPs: flavorCYPs
  }), componentContainer);
}
export function initOneThreeSixPDPFlavorSelector(_ref2) {
  var buy1Container = _ref2.buy1Container,
      buy3Container = _ref2.buy3Container,
      buy6Container = _ref2.buy6Container,
      buy1SnsContainer = _ref2.buy1SnsContainer,
      buy3SnsContainer = _ref2.buy3SnsContainer,
      buy6SnsContainer = _ref2.buy6SnsContainer,
      buy1SnsSellingPlanId = _ref2.buy1SnsSellingPlanId,
      buy3SnsSellingPlanId = _ref2.buy3SnsSellingPlanId,
      buy6SnsSellingPlanId = _ref2.buy6SnsSellingPlanId,
      rootElement = _ref2.rootElement,
      product = _ref2.product,
      productOverride = _ref2.productOverride;
  Modal.setAppElement(rootElement);
  var componentContainer = document.createElement('div');
  document.body.appendChild(componentContainer);
  ReactDOM.render( /*#__PURE__*/React.createElement(PDPOneThreeSixFlavorSelector, {
    buy1ButtonContainer: buy1Container,
    buy3ButtonContainer: buy3Container,
    buy6ButtonContainer: buy6Container,
    buy1SnsButtonContainer: buy1SnsContainer,
    buy3SnsButtonContainer: buy3SnsContainer,
    buy6SnsButtonContainer: buy6SnsContainer,
    buy1SnsSellingPlanId: buy1SnsSellingPlanId,
    buy3SnsSellingPlanId: buy3SnsSellingPlanId,
    buy6SnsSellingPlanId: buy6SnsSellingPlanId,
    product: product,
    productOverride: productOverride
  }), componentContainer);
}
export function initVIPFlavorSelector(_ref3) {
  var buyButtonContainer = _ref3.buyButtonContainer,
      quantityInput = _ref3.quantityInput,
      rootElement = _ref3.rootElement,
      product = _ref3.product;
  Modal.setAppElement(rootElement);
  var componentContainer = document.createElement('div');
  document.body.appendChild(componentContainer);
  ReactDOM.render( /*#__PURE__*/React.createElement(VIPFlavorSelector, {
    buyButtonContainer: buyButtonContainer,
    product: product,
    quantityInput: quantityInput
  }), componentContainer);
}